import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const athlon = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            hero: {
                'title': '<strong>{{organization}}<br>Werkstatt-Buchung</strong>',
                'subtitle': null,
            },
            welcomeModal: {
                'title': 'Sie verlassen nun die Seite von Athlon',
                'text': 'Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt Athlon nicht verantwortlich ist und die Datenschutzbestimmungen von Athlon keine Anwendung finden.',
            },
            layout: {
                backText: 'Zurück zu athlon.com'
            },
            benefits: {
                'bullet-point-3': '',
                'feedbackTitle': 'Feedback',
            },
            linkToHome: 'https://werkstatt.repareo.de/partner/athlon',
            chooseSubServices: 'Sollen weitere Services erledigt werden?',
            contact: {
                'title': 'Kontakt',
                'text': 'Bestehen noch Fragen zur Buchung? Wir kümmern uns gerne persönlich um Ihr Anliegen.',
                'partner-text': 'Technischer Service {{organization}}',
                'phone': 'Telefon',
                'phone-link-repareo': 'tel:004989244182010',
                'phone-link-leaseplan': 'tel:004989244182013',
                'phone-repareo': '+49 89 244 182 010',
                'phone-leaseplan': '+49 89 244 182 013',
                'reachability': '(werktags 8-20 Uhr)',
                'reachability-repareo': '8 - 20 Uhr | Montag - Samstag',
                'reachability-partner': '8 - 18 Uhr | Montag - Freitag',
                'reachability-leaseplan': '8 - 18 Uhr | Montag - Donnerstag\n8 - 17 Uhr | Freitag',
                'email': 'E-Mail',
            },
        },
    }
}
